import * as React from 'react'
import Button from '@doordash/component-button'
import { Text, Colors, Stack, StackChildren } from '@doordash/design-language'
import Form from '../../../../utilities/Form'
import { validators as sharedValidators } from '../../../../utilities/validators'
import { BirthdateInputSplit } from '../../../atoms/birthdate-input'
import { VehicleTypeDropdown } from '../../../atoms/vehicle-type-dropdown'
import styled from 'styled-components'

import t from './strings'

const PageExplanation = styled(Text)`
  color: gray;
`

type Props = {
  uniqueLink?: string
  requestedBgCheckCopy?: boolean
  error?: string
  onSubmit?: (any) => Promise<any>
  doSubmit?: (uniqueLink: string, backgroundInfo: object) => Promise<any>
  vehicleTypes?: any
}

class Canada extends React.Component<Props> {
  public static fields = {
    vehicleType: -1,
    birthday: '',
  }

  public static validators = {
    vehicleType: sharedValidators.vehicleType,
    birthday: sharedValidators.birthday,
  }

  public processVehicleTypes = vehicleTypes => {
    const vehicleTypesArray = []
    for (const key of Object.keys(vehicleTypes)) {
      const obj = vehicleTypes[key]
      obj.value = key
      vehicleTypesArray.push(obj)
    }

    return vehicleTypesArray
  }

  public handleSubmit = async data => {
    const { doSubmit, uniqueLink } = this.props
    try {
      const res = await doSubmit(uniqueLink, data)
      return res
    } catch (e) {
      throw e
    }
  }

  public render() {
    const { vehicleTypes } = this.props

    return (
      <React.Fragment>
        <Text color={Colors.SystemRed60} styles={Text.Styles.MajorPageTitle}>
          {t.title()}
        </Text>

        <Form
          onSubmit={this.handleSubmit}
          validators={Canada.validators}
          fields={Canada.fields}
        >
          {(fields, handleChange, handleSubmit, { isLoading }) => (
            <form onSubmit={handleSubmit}>
              <PageExplanation>{t.vehicleExplanation()}</PageExplanation>
              <Stack />
              <StackChildren size={StackChildren.Sizes.Large}>
                <VehicleTypeDropdown
                  label={t.vehicleTypeLabel()}
                  description={t.required()}
                  vehicleTypes={this.processVehicleTypes(vehicleTypes)}
                  onChange={handleChange.bind(this, 'vehicleType')}
                  {...fields.vehicleType}
                />
                <BirthdateInputSplit
                  id="birthdate-input-split"
                  label={t.birthdate()}
                  onChange={handleChange.bind(this, 'birthday')}
                  birthdayField={fields.birthday}
                  {...fields.birthday}
                />
                <Button
                  onClick={async () => {
                    try {
                      await handleSubmit()
                    } catch (e) {
                      console.warn(e)
                    }
                  }}
                  state={
                    isLoading ? Button.States.Loading : Button.States.Default
                  }
                >
                  {t.continue()}
                </Button>
              </StackChildren>
            </form>
          )}
        </Form>
      </React.Fragment>
    )
  }
}

export default Canada
